
  // @ts-ignore -- Unused import
  import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
  // @ts-ignore -- Unused import
  import { jsonLightReadStringPropertyValue } from '@msdyn365-commerce/retail-proxy/dist/externals';

  
    /**
    * GetProductPackagingPropsResponse entity interface.
    */
    export interface IGetProductPackagingPropsResponse {
    PackagingQty: number;
    InventUnitId?: string;
    PropsFound: boolean;
    Error: boolean;
    ErrorMessage?: string;
    }
  
    /**
    * GetProductCustomerPricesResponse entity interface.
    */
    export interface IGetProductCustomerPricesResponse {
    PriceFound: boolean;
    Error: boolean;
    ErrorMessage?: string;
    ProductCustomerTradeAgreements?: IProductCustomerTradeAgreement[];
    }
  
    /**
    * ProductCustomerTradeAgreement entity interface.
    */
    export interface IProductCustomerTradeAgreement {
    SalesPrice: number;
    FromQty: number;
    UnitId?: string;
    }
  
  /**
   * GetProductPackagingPropsResponse entity class.
   */
  export class GetProductPackagingPropsResponseExtensionClass implements IGetProductPackagingPropsResponse {
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public PackagingQty: number;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public InventUnitId: string;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public PropsFound: boolean;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public Error: boolean;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public ErrorMessage: string;
      
      // Navigation properties names
      
      /**
       * Construct an object from odata response.
       * @param {any} odataObject The odata result object.
       */
      constructor(odataObject?: any) {
      odataObject = odataObject || {};
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.PackagingQty = (odataObject.PackagingQty) ? parseFloat(odataObject.PackagingQty) : 0;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.InventUnitId = odataObject.InventUnitId;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.PropsFound = odataObject.PropsFound;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.Error = odataObject.Error;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.ErrorMessage = odataObject.ErrorMessage;
              
      }
  }

  /**
   * GetProductCustomerPricesResponse entity class.
   */
  export class GetProductCustomerPricesResponseExtensionClass implements IGetProductCustomerPricesResponse {
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public PriceFound: boolean;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public Error: boolean;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public ErrorMessage: string;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public ProductCustomerTradeAgreements: 
            IProductCustomerTradeAgreement[];
      
      // Navigation properties names
      
      /**
       * Construct an object from odata response.
       * @param {any} odataObject The odata result object.
       */
      constructor(odataObject?: any) {
      odataObject = odataObject || {};
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.PriceFound = odataObject.PriceFound;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.Error = odataObject.Error;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.ErrorMessage = odataObject.ErrorMessage;
              
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ProductCustomerTradeAgreements = undefined;
        if (odataObject.ProductCustomerTradeAgreements) {
          this.ProductCustomerTradeAgreements = [];
          for (var i = 0; i < odataObject.ProductCustomerTradeAgreements.length; i++) {
            if (odataObject.ProductCustomerTradeAgreements[i]) {
        if (odataObject.ProductCustomerTradeAgreements[i]['@odata.type']) {
          var className: string = odataObject.ProductCustomerTradeAgreements[i]['@odata.type'];
          className = className.substr(className.lastIndexOf('.') + 1).concat("Class");
          if (EntityClasses[className]) {
            this.ProductCustomerTradeAgreements[i] = new EntityClasses[className](odataObject.ProductCustomerTradeAgreements[i]);
          }
        } else {
          this.ProductCustomerTradeAgreements[i] = new ProductCustomerTradeAgreementExtensionClass(odataObject.ProductCustomerTradeAgreements[i]);
        }
      
            } else {
              // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
              this.ProductCustomerTradeAgreements[i] = undefined;
            }
          }
        }
      
      }
  }

  /**
   * ProductCustomerTradeAgreement entity class.
   */
  export class ProductCustomerTradeAgreementExtensionClass implements IProductCustomerTradeAgreement {
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public SalesPrice: number;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public FromQty: number;
      
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        public UnitId: string;
      
      // Navigation properties names
      
      /**
       * Construct an object from odata response.
       * @param {any} odataObject The odata result object.
       */
      constructor(odataObject?: any) {
      odataObject = odataObject || {};
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.SalesPrice = (odataObject.SalesPrice) ? parseFloat(odataObject.SalesPrice) : 0;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.FromQty = (odataObject.FromQty) ? parseFloat(odataObject.FromQty) : 0;
              
            // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
            this.UnitId = odataObject.UnitId;
              
      }
  }
